import type { ReactNode } from 'react';
import { motion } from 'framer-motion';

interface SectionCardProps {
  eyebrow?: string;
  title: string;
  action?: ReactNode;
  children: ReactNode;
  fillHeight?: boolean;
}

export function SectionCard({ eyebrow, title, action, children, fillHeight }: SectionCardProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      className={`glass rounded-2xl border border-gray-200 dark:border-white/10 p-5 shadow-lg ${fillHeight ? 'flex-1 flex flex-col min-h-0' : ''}`}
    >
      <div className="flex items-start justify-between gap-4 mb-4 shrink-0">
        <div>
          {eyebrow && (
            <p className="text-xs uppercase tracking-wide text-primary-600 dark:text-primary-400 mb-1 font-semibold">
              {eyebrow}
            </p>
          )}
          <h2 className="text-xl font-semibold text-gray-900 dark:text-white">{title}</h2>
        </div>
        {action}
      </div>
      <div className={fillHeight ? 'flex-1 min-h-0 flex flex-col' : ''}>{children}</div>
    </motion.div>
  );
}
